/*------------------------------------*\
    BABEL POLYFILL
\*------------------------------------*/
import "babel-polyfill";

/*------------------------------------*\
    MODULES
\*------------------------------------*/
import TypeMate from 'typemate';
import Accordion from './modules/accordion';
import BenefitsAccordion from './modules/benefits-accordion';
import CardCarousel from './modules/card-carousel';
import Dropdowns from './modules/dropdowns';
import DataTable from './modules/data-table';
import ExampleModule from './modules/example-module';
import InvestMentCard from './modules/investment-card';
import MainNav from './modules/main-nav';
import HomepageCarousel from './modules/homepage-carousel';
import GalleryCarousel from './modules/gallery-carousel';
import SubnavSticky from './modules/subnav-sticky';
import Tabs from './modules/tabs';
import VideoModal from './modules/video-modal';
import ScrollTo from './modules/scroll-to';
import AjaxGrid from './modules/ajax-grid';
import SignupAnalytics from './modules/signup-analytics';
import "zoom-vanilla.js/dist/zoom-vanilla.min.js";
import zoomedImg from './modules/zoomed-img';
import Modal from './modules/modal';

/*------------------------------------*
    APP
\*------------------------------------*/
const app = {

    init() {
        this.noJs();
        this.alwaysLoad();
        this.nodelistPolyfill();
        this.bind();
    },

    bind() {

        // Load any items that need modules
        let modulePlaceHolders = [...document.querySelectorAll('[data-module]')];

        // No modules so bail
        if (!modulePlaceHolders.length) {
            return;
        }

        modulePlaceHolders.map((item) => {

            // Attempt to load any modules
            let modules = item.getAttribute('data-module');

            if (!modules.length) {
                return false;
            }

            // Split the modules into an array
            modules = modules.trim().split(',');

            // Loop and bind to relevant modules
            modules.map((module) => {

                switch (module) {

                    // This is an example; delete it when you add your own cases.
                    case 'example-module':

                        let exampleModuleInstance = new ExampleModule(item);

                        exampleModuleInstance.init();

                        break;

                    case 'investment-card':

                        let investmentCardInstance = new InvestMentCard(item);
                        investmentCardInstance.init();

                        break;

                    case 'main-nav':

                        let mainNavInstance = new MainNav(item);
                        mainNavInstance.init();

                        break;

                    case 'benefits-accordion':

                        let benefitsAccordionInstance = new BenefitsAccordion(item);
                        benefitsAccordionInstance.init();

                        break;

                    case 'homepage-carousel':

                        let homepageCarouselInstance = new HomepageCarousel(item);
                        homepageCarouselInstance.init();

                        break;

                    case 'card-carousel':

                        let cardCarouselInstance = new CardCarousel(item);
                        cardCarouselInstance.init();

                        break;

                    case 'gallery-carousel':

                        let galleryCarouselInstance = new GalleryCarousel(item);
                        galleryCarouselInstance.init();

                        break;

                    case 'data-table':

                        let dataTableInstance = new DataTable(item);
                        dataTableInstance.init();

                        break;
                    case 'tabs':

                        let tabsInstance = new Tabs(item);
                        tabsInstance.init();

                        break;
                    case 'subnav':

                        let subnavStickyInstance = new SubnavSticky(item);
                        subnavStickyInstance.init();

                        break;
                    case 'dropdowns':

                        let dropdownsInstance = new Dropdowns(item);
                        dropdownsInstance.init();

                        break;
                    case 'accordion':

                        let accordionInstance = new Accordion(item);
                        accordionInstance.init();

                        break;
                    case 'video-modal':

                        let videoModalInstance = new VideoModal(item);
                        videoModalInstance.init();

                        break;
                    case 'scroll-to':

                        let scrollToInstance = new ScrollTo(item);
                        scrollToInstance.init();

                        break;

                    case 'ajax-grid':

                        let ajaxGridInstance = new AjaxGrid(item);
                        ajaxGridInstance.init();

                        break;

                    case 'signup-analytics':

                        let signupAnalyticsInstance = new SignupAnalytics(item);
                        signupAnalyticsInstance.init();

                        break;

                    case 'js-zoomed-image':

                        let zoomedImageInstance = new zoomedImg(item);

                        zoomedImageInstance.init();

                        break;

                    case 'modal':

                        let modalInstance = new Modal(item);

                        modalInstance.init();
                }
            });
        });
    },

    alwaysLoad() {
        // const typeMateInstance = new TypeMate();
        // typeMateInstance.apply();
    },

    noJs() {
        document.documentElement.classList.remove('no-js');
        document.documentElement.classList.add('js');
    },

    nodelistPolyfill() {
        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = function (callback, thisArg) {
                thisArg = thisArg || window;
                for (var i = 0; i < this.length; i++) {
                    callback.call(thisArg, this[i], i, this);
                }
            };
        }
    }
};

// Launch
app.init();
